import React from "react";
import Panel from "muicss/lib/react/panel";
import BigNumber from "bignumber.js";

export default class AmountWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  renderName() {
    return null;
  }

  render() {
    let amountBig;
    let amount;
    if (this.state.loading) {
      amountBig = "Loading...";
    } else {
      if (this.state.amount >= 1000000000) {
        amountBig = Math.floor(this.state.amount / 10000000) / 100 + "B";
      } else if (this.state.amount >= 1000000) {
        amountBig = Math.floor(this.state.amount / 10000) / 100 + "M";
      } else if (this.state.amount < 1000000 && this.state.amount >= 100000) {
        amountBig = Math.floor(this.state.amount / 1000) + "k";
      } else {
        amountBig = Math.floor(this.state.amount);
      }

      if (this.state.code) {
        amountBig += ` ${this.state.code}`;
      }

      amount = new BigNumber(this.state.amount).toFormat(7);
    }

    return (
      <Panel style={{height:270}}>
        <div className="widget-name">{this.renderName()}</div>
        <div className="mui--text-display3 mui--text-center">{amountBig}</div>
        <div className="mui--text-caption mui--text-center">
          {this.state.loading ? (
            ""
          ) : (
            <span>
              {amount} {this.state.code}
            </span>
          )}
        </div>
        {this.state.public != undefined ?
          <div style={{width:'100%' , display:'flex' , flexDirection:'column' , justifyContent: 'center', alignItems:'center' , marginTop: 10 }}>
            <br/>
            <div style={{width: 90 , backgroundColor : '#ff6f00' , textAlign : 'center'}}>
              <b style={{color: '#fff' , fontSize : '0.8em'}}>{this.props.dictionary['public'][this.props.lang]}</b>
            </div>
            <p style={{width: '100%' , textAlign:'center' , overflowWrap:'break-word' , marginTop : 10}}>
              {this.state.public.length > 0 && this.state.public}
            </p>

          </div>
        :
        null}

      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/components/AmountWidget.js